import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/pro-solid-svg-icons";

interface WarningInformationBoxProps {
  children: ReactNode;
}

export const WarningInformationBox: React.FC<WarningInformationBoxProps> = ({
  children,
}) => {
  return (
    <div className="warning-information-box-container">
      <FontAwesomeIcon icon={faWarning} />
      <div>{children}</div>
    </div>
  );
};
